import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-results',
  templateUrl: './payment-results.component.html',
  styleUrls: ['./payment-results.component.css']
})
export class PaymentResultsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
